import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Column, ProductTable } from '../product-table/product-table';
import { ProductFilter, SearchFilter } from '../product-filter/product-filter';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'app-product-list',
  imports: [CommonModule, ProductFilter, ProductTable],
  templateUrl: './product-list.html'
})
export class ProductList {
  filters!: SearchFilter;
  filtersSubject = new Subject<SearchFilter>();

  columns: Column[] = [];
  columnsSubject = new Subject<Column[]>();

  constructor() {
    this.filtersSubject.pipe(debounceTime(600)).subscribe(filters => this.filters = {...filters});
    this.columnsSubject.pipe(debounceTime(600)).subscribe(columns => this.columns = [...columns]);
  }

  filtersChange(filters: SearchFilter) {
    this.filtersSubject.next(filters);
  }

  columnChange(columns: Column[]) {
    this.columnsSubject.next(columns);
  }
}
